import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { SetComponentLanguage } from '../../../helpers';
import ReactHtmlParser from 'react-html-parser';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './StreamBootedModal.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class StreamBootedModal extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() { 
		return ( 
			<div>
		  		<Modal isOpen={this.props.isBootedModalOpen} className="modal-booted">
		          	<ModalHeader>{strings.title}</ModalHeader>
		          	<ModalBody>
						{ReactHtmlParser(strings.error)}
		          	</ModalBody>
		          	<ModalFooter className="text-center">
						<button 
						  	type="button" 
							className="showtix-button showtix-background__primary-1"
							onClick={this.props.refreshPageAfterBooted}
						>
							<span>{strings.refresh}</span>
						</button>
		          	</ModalFooter>
		        </Modal>
			</div>
		)
	}
}

StreamBootedModal.propTypes = {
	isBootedModalOpen: PropTypes.bool,
	toggleBootedModal: PropTypes.func,
	refreshPageAfterBooted: PropTypes.func
};
 
export default StreamBootedModal;


// WEBPACK FOOTER //
// ./src/components/Stream/StreamBootedModal/StreamBootedModal.js